import * as i0 from '@angular/core';
import { Injectable, NgModule } from '@angular/core';
import * as i1$1 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i1$2 from '@spartacus/core';
import { provideDefaultConfig, HttpErrorHandler, HttpResponseStatus, Priority, GlobalMessageType, provideDefaultConfigFactory } from '@spartacus/core';
import * as i2 from '@spartacus/storefront';
import { BREAKPOINT, PAGE_LAYOUT_HANDLER, HamburgerMenuModule, PageLayoutComponent, CmsPageGuard } from '@spartacus/storefront';
import * as i1 from '@spartacus/product-configurator/common';
import { ConfiguratorRouter, CommonConfiguratorModule } from '@spartacus/product-configurator/common';
import { take, map, switchMap } from 'rxjs/operators';
import { CommonModule } from '@angular/common';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CpqConfiguratorPageLayoutHandler = /*#__PURE__*/(() => {
  class CpqConfiguratorPageLayoutHandler {
    static {
      this.templateName = 'CpqConfigurationTemplate';
    }
    static {
      this.sectionHeaderDisplayOnly = 'headerDisplayOnly';
    }
    static {
      this.sectionNavigationDisplayOnly = 'navigationDisplayOnly';
    }
    static {
      this.sectionHeader = 'header';
    }
    static {
      this.sectionNavigation = 'navigation';
    }
    constructor(configuratorRouterExtractorService, breakpointService, layoutConfig, commonConfiguratorUtilsService) {
      this.configuratorRouterExtractorService = configuratorRouterExtractorService;
      this.breakpointService = breakpointService;
      this.layoutConfig = layoutConfig;
      this.commonConfiguratorUtilsService = commonConfiguratorUtilsService;
    }
    handle(slots$, pageTemplate, section) {
      if (pageTemplate === CpqConfiguratorPageLayoutHandler.templateName && section === CpqConfiguratorPageLayoutHandler.sectionHeader) {
        this.compileRouterAndResolution().pipe(take(1)).subscribe(cont => {
          slots$ = slots$.pipe(map(slots => this.getHeaderSlots(slots, cont)));
        });
      } else if (pageTemplate === CpqConfiguratorPageLayoutHandler.templateName && section === CpqConfiguratorPageLayoutHandler.sectionNavigation) {
        this.compileRouterAndResolution().pipe(take(1)).subscribe(cont => {
          slots$ = slots$.pipe(map(slots => this.getNavigationSlots(slots, cont)));
        });
      }
      return slots$;
    }
    compileRouterAndResolution() {
      return this.configuratorRouterExtractorService.extractRouterData().pipe(switchMap(routerData => this.breakpointService.isUp(BREAKPOINT.lg).pipe(map(isLargeResolution => ({
        isLargeResolution: isLargeResolution,
        routerData
      })))));
    }
    getHeaderSlots(slots, cont) {
      if (cont.routerData.pageType === ConfiguratorRouter.PageType.CONFIGURATION) {
        const extendedSlots = ['PreHeader'];
        extendedSlots.push(...slots);
        return extendedSlots;
      } else if (cont.routerData.displayOnly) {
        if (cont.isLargeResolution) {
          return this.commonConfiguratorUtilsService.getSlotsFromLayoutConfiguration(this.layoutConfig, CpqConfiguratorPageLayoutHandler.templateName, CpqConfiguratorPageLayoutHandler.sectionHeaderDisplayOnly, BREAKPOINT.lg);
        } else {
          return this.commonConfiguratorUtilsService.getSlotsFromLayoutConfiguration(this.layoutConfig, CpqConfiguratorPageLayoutHandler.templateName, CpqConfiguratorPageLayoutHandler.sectionHeaderDisplayOnly, BREAKPOINT.xs);
        }
      } else {
        return slots;
      }
    }
    getNavigationSlots(slots, cont) {
      if (cont.routerData.pageType === ConfiguratorRouter.PageType.OVERVIEW && cont.routerData.displayOnly) {
        if (cont.isLargeResolution) {
          return this.commonConfiguratorUtilsService.getSlotsFromLayoutConfiguration(this.layoutConfig, CpqConfiguratorPageLayoutHandler.templateName, CpqConfiguratorPageLayoutHandler.sectionNavigationDisplayOnly, BREAKPOINT.lg);
        } else {
          return this.commonConfiguratorUtilsService.getSlotsFromLayoutConfiguration(this.layoutConfig, CpqConfiguratorPageLayoutHandler.templateName, CpqConfiguratorPageLayoutHandler.sectionNavigationDisplayOnly, BREAKPOINT.xs);
        }
      } else {
        return slots;
      }
    }
    static {
      this.ɵfac = function CpqConfiguratorPageLayoutHandler_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CpqConfiguratorPageLayoutHandler)(i0.ɵɵinject(i1.ConfiguratorRouterExtractorService), i0.ɵɵinject(i2.BreakpointService), i0.ɵɵinject(i2.LayoutConfig), i0.ɵɵinject(i1.CommonConfiguratorUtilsService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CpqConfiguratorPageLayoutHandler,
        factory: CpqConfiguratorPageLayoutHandler.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return CpqConfiguratorPageLayoutHandler;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 *  Contains the layout configuration for the CPQ configurator pages. This configuration is
 *  optional as of version 4.2, and reduces the components that are rendered in the header section.
 *  It needs to be explicitly imported, otherwise the default configuration
 *  from CpqConfiguratorInteractiveModule is active
 */
let CpqConfiguratorLayoutModule = /*#__PURE__*/(() => {
  class CpqConfiguratorLayoutModule {
    static {
      this.ɵfac = function CpqConfiguratorLayoutModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CpqConfiguratorLayoutModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CpqConfiguratorLayoutModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfig({
          layoutSlots: {
            CpqConfigurationTemplate: {
              header: {
                lg: {
                  slots: ['SiteLogo', 'CpqConfigExitButton', 'MiniCart']
                },
                xs: {
                  slots: ['SiteLogo', 'CpqConfigExitButton', 'MiniCart']
                }
              },
              headerDisplayOnly: {
                lg: {
                  slots: ['SiteContext', 'SiteLinks', 'SiteLogo', 'SearchBox', 'SiteLogin', 'MiniCart', 'NavigationBar']
                },
                xs: {
                  slots: ['PreHeader', 'SiteLogo', 'SearchBox', 'MiniCart']
                }
              },
              navigation: {
                lg: {
                  slots: []
                },
                slots: ['CpqConfigMenu']
              },
              navigationDisplayOnly: {
                lg: {
                  slots: []
                },
                xs: {
                  slots: ['SiteLogin', 'NavigationBar', 'SiteContext', 'SiteLinks']
                }
              },
              lg: {
                slots: ['CpqConfigHeader', 'CpqConfigBanner', 'CpqConfigMenu', 'CpqConfigContent', 'CpqConfigOverviewBanner', 'CpqConfigOverviewContent', 'CpqConfigBottombar']
              },
              slots: ['CpqConfigHeader', 'CpqConfigBanner', 'CpqConfigContent', 'CpqConfigOverviewBanner', 'CpqConfigOverviewContent', 'CpqConfigBottombar']
            }
          }
        }), {
          provide: PAGE_LAYOUT_HANDLER,
          useExisting: CpqConfiguratorPageLayoutHandler,
          multi: true
        }]
      });
    }
  }
  return CpqConfiguratorLayoutModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultCpqInteractiveRoutingConfig = {
  routing: {
    routes: {
      configureCLOUDCPQCONFIGURATOR: {
        paths: ['configure/cpq/:ownerType/entityKey/:entityKey']
      }
    }
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Takes care of the interactive configuration process (the user enters new attribute values and navigates through the configuration).
 * Provides routing, assignment of ng components to CMS components and assignment of CMS components to the layout slots
 */
let CpqConfiguratorInteractiveModule = /*#__PURE__*/(() => {
  class CpqConfiguratorInteractiveModule {
    static {
      this.ɵfac = function CpqConfiguratorInteractiveModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CpqConfiguratorInteractiveModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CpqConfiguratorInteractiveModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfig(defaultCpqInteractiveRoutingConfig)],
        imports: [RouterModule.forChild([{
          // We can neither omit the path nor set to undefined
          // @ts-ignore
          path: null,
          data: {
            cxRoute: 'configureCLOUDCPQCONFIGURATOR'
          },
          component: PageLayoutComponent,
          canActivate: [CmsPageGuard]
        }]), HamburgerMenuModule, CpqConfiguratorLayoutModule]
      });
    }
  }
  return CpqConfiguratorInteractiveModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultCpqOverviewRoutingConfig = {
  routing: {
    routes: {
      configureOverviewCLOUDCPQCONFIGURATOR: {
        paths: ['configure-overview/cpq/:ownerType/entityKey/:entityKey/displayOnly/:displayOnly', 'configure-overview/cpq/:ownerType/entityKey/:entityKey']
      }
    }
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Takes care of the configuration overview that visualizes the attribute value assignments that have been done already in a condensed, read-only form.
 * The end-user can switch between the interactive view and this overview.
 * Provides routing, assignment of ng components to CMS components and assignment of CMS components to the layout slots.
 * Some of the ng components on this view (tab bar, price summary and addToCart button) are shared between the interactive view and the overview.
 */
let CpqConfiguratorOverviewModule = /*#__PURE__*/(() => {
  class CpqConfiguratorOverviewModule {
    static {
      this.ɵfac = function CpqConfiguratorOverviewModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CpqConfiguratorOverviewModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CpqConfiguratorOverviewModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfig(defaultCpqOverviewRoutingConfig)],
        imports: [RouterModule.forChild([{
          // We can neither omit the path nor set to undefined
          // @ts-ignore
          path: null,
          component: PageLayoutComponent,
          data: {
            cxRoute: 'configureOverviewCLOUDCPQCONFIGURATOR'
          },
          canActivate: [CmsPageGuard]
        }]), CpqConfiguratorLayoutModule]
      });
    }
  }
  return CpqConfiguratorOverviewModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Exposes the CPQ aspects that we need to load eagerly, like page mappings, routing
 * and interceptor related entities
 */
let CpqConfiguratorRootModule = /*#__PURE__*/(() => {
  class CpqConfiguratorRootModule {
    static {
      this.ɵfac = function CpqConfiguratorRootModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CpqConfiguratorRootModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CpqConfiguratorRootModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfig({
          routing: {
            protected: true
          }
        })],
        imports: [CpqConfiguratorInteractiveModule, CpqConfiguratorOverviewModule]
      });
    }
  }
  return CpqConfiguratorRootModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const PRODUCT_CONFIGURATOR_RULEBASED_FEATURE = 'productConfiguratorRulebased';
let ConfiguratorBadRequestHandler = /*#__PURE__*/(() => {
  class ConfiguratorBadRequestHandler extends HttpErrorHandler {
    constructor(globalMessageService) {
      super(globalMessageService);
      this.globalMessageService = globalMessageService;
      this.responseStatus = HttpResponseStatus.BAD_REQUEST;
    }
    getPriority() {
      return Priority.NORMAL;
    }
    hasMatch(errorResponse) {
      return super.hasMatch(errorResponse) && this.isRelatedToProductConfigurator(errorResponse);
    }
    handleError(_request, response) {
      this.getIllegalStateErrorsRelatedToProductConfigurator(response).forEach(({
        message
      }) => {
        this.handleIllegalArgumentIssues(message);
      });
    }
    handleIllegalArgumentIssues(message) {
      if (this.isIllegalStateErrorRelatedToMakeToStock(message)) {
        this.globalMessageService.add({
          key: 'configurator.httpHandlers.makeToStockBaseProductIssue'
        }, GlobalMessageType.MSG_TYPE_ERROR);
      }
    }
    isNotEmpty(errors) {
      return errors?.length > 0;
    }
    isIllegalStateErrorRelatedToMakeToStock(message) {
      const discountMask = /base product is defined as 'make-to-stock'/;
      return message.match(discountMask) !== null;
    }
    isIllegalStateErrorRelatedToProductConfigurator(message) {
      return message && this.isIllegalStateErrorRelatedToMakeToStock(message);
    }
    getIllegalStateErrorsRelatedToProductConfigurator(response) {
      return (response?.error?.errors ?? []).filter(error => error.type === 'IllegalStateError').filter(error => this.isIllegalStateErrorRelatedToProductConfigurator(error.message));
    }
    isRelatedToProductConfigurator(response) {
      return this.isNotEmpty(this.getIllegalStateErrorsRelatedToProductConfigurator(response));
    }
    static {
      this.ɵfac = function ConfiguratorBadRequestHandler_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ConfiguratorBadRequestHandler)(i0.ɵɵinject(i1$2.GlobalMessageService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ConfiguratorBadRequestHandler,
        factory: ConfiguratorBadRequestHandler.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ConfiguratorBadRequestHandler;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const cmsComponents = ['ConfiguratorForm', 'ConfiguratorOverviewForm', 'ConfiguratorOverviewMenu', 'ConfiguratorUpdateMessage', 'ConfiguratorAddToCartButton', 'ConfiguratorMenu', 'ConfiguratorGroupTitle', 'ConfiguratorOverviewBanner', 'ConfiguratorPrevNext', 'ConfiguratorPriceSummary', 'ConfiguratorProductTitle', 'ConfiguratorTabBar', 'ConfiguratorExitButton', 'ConfiguratorVariantCarousel', 'CpqConfiguratorConflictAndErrorMessagesComponent', 'ConfiguratorOverviewFilterButton', 'ConfiguratorOverviewFilter', 'ConfiguratorOverviewSidebar'];
// TODO: Inline this factory when we start releasing Ivy compiled libraries
function defaultProductConfiguratorRulebasedComponentsConfig() {
  const config = {
    featureModules: {
      [PRODUCT_CONFIGURATOR_RULEBASED_FEATURE]: {
        cmsComponents
      }
    }
  };
  return config;
}
/**
 * Contains feature module configuration
 */
let RulebasedConfiguratorRootFeatureModule = /*#__PURE__*/(() => {
  class RulebasedConfiguratorRootFeatureModule {
    static {
      this.ɵfac = function RulebasedConfiguratorRootFeatureModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || RulebasedConfiguratorRootFeatureModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: RulebasedConfiguratorRootFeatureModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfigFactory(defaultProductConfiguratorRulebasedComponentsConfig)]
      });
    }
  }
  return RulebasedConfiguratorRootFeatureModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultRulebasedRoutingConfig = {
  routing: {
    routes: {
      configureCPQCONFIGURATOR: {
        paths: ['configure/vc/:ownerType/entityKey/:entityKey']
      },
      configureCPQCONFIGURATOR_READ_ONLY: {
        paths: ['configure-overview/vc/:ownerType/entityKey/:entityKey/displayOnly/true']
      },
      configureOverviewCPQCONFIGURATOR: {
        paths: ['configure-overview/vc/:ownerType/entityKey/:entityKey/displayOnly/:displayOnly', 'configure-overview/vc/:ownerType/entityKey/:entityKey']
      }
    }
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Provides the default cx routing configuration for the rulebased configurator
 */
let RulebasedConfiguratorRoutingModule = /*#__PURE__*/(() => {
  class RulebasedConfiguratorRoutingModule {
    static forRoot() {
      return {
        ngModule: RulebasedConfiguratorRoutingModule,
        providers: [provideDefaultConfig(defaultRulebasedRoutingConfig)]
      };
    }
    static {
      this.ɵfac = function RulebasedConfiguratorRoutingModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || RulebasedConfiguratorRoutingModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: RulebasedConfiguratorRoutingModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return RulebasedConfiguratorRoutingModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 *  Contains the layout configuration for the interactive configuration page. This configuration is
 *  optional as of version 4.2, and reduces the components that are rendered in the header section.
 *  It needs to be explicitly imported, otherwise the default configuration
 *  from VariantConfiguratorInteractiveModule is active
 */
let VariantConfiguratorInteractiveLayoutModule = /*#__PURE__*/(() => {
  class VariantConfiguratorInteractiveLayoutModule {
    static {
      this.ɵfac = function VariantConfiguratorInteractiveLayoutModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VariantConfiguratorInteractiveLayoutModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: VariantConfiguratorInteractiveLayoutModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfig({
          layoutSlots: {
            VariantConfigurationTemplate: {
              header: {
                lg: {
                  slots: ['PreHeader', 'SiteLogo', 'VariantConfigExitButton', 'MiniCart']
                },
                xs: {
                  slots: ['PreHeader', 'SiteLogo', 'VariantConfigExitButton', 'MiniCart']
                }
              },
              navigation: {
                lg: {
                  slots: []
                },
                slots: ['VariantConfigMenu']
              },
              lg: {
                slots: ['VariantConfigHeader', 'VariantConfigMenu', 'VariantConfigContent', 'VariantConfigBottombar', 'VariantConfigVariantCarousel']
              },
              slots: ['VariantConfigHeader', 'VariantConfigContent', 'VariantConfigBottombar', 'VariantConfigVariantCarousel']
            }
          }
        })]
      });
    }
  }
  return VariantConfiguratorInteractiveLayoutModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Takes care of the interactive configuration process (the user enters new attribute values and navigates through the configuration).
 * Provides routing, assignment of ng components to CMS components and assignment of CMS components to the layout slots
 */
let VariantConfiguratorInteractiveModule = /*#__PURE__*/(() => {
  class VariantConfiguratorInteractiveModule {
    static {
      this.ɵfac = function VariantConfiguratorInteractiveModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VariantConfiguratorInteractiveModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: VariantConfiguratorInteractiveModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [RouterModule.forChild([{
          // We can neither omit the path nor set to undefined
          // @ts-ignore
          path: null,
          data: {
            cxRoute: 'configureCPQCONFIGURATOR'
          },
          component: PageLayoutComponent,
          canActivate: [CmsPageGuard]
        }]), HamburgerMenuModule, VariantConfiguratorInteractiveLayoutModule]
      });
    }
  }
  return VariantConfiguratorInteractiveModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let VariantConfiguratorPageLayoutHandler = /*#__PURE__*/(() => {
  class VariantConfiguratorPageLayoutHandler {
    static {
      this.templateName = 'VariantConfigurationOverviewTemplate';
    }
    static {
      this.sectionDisplayOnlyName = 'headerDisplayOnly';
    }
    constructor(configuratorRouterExtractorService, breakpointService, layoutConfig, commonConfiguratorUtilsService) {
      this.configuratorRouterExtractorService = configuratorRouterExtractorService;
      this.breakpointService = breakpointService;
      this.layoutConfig = layoutConfig;
      this.commonConfiguratorUtilsService = commonConfiguratorUtilsService;
    }
    handle(slots$, pageTemplate, section) {
      if (pageTemplate === VariantConfiguratorPageLayoutHandler.templateName && section === 'header') {
        this.configuratorRouterExtractorService.extractRouterData().pipe(take(1)).subscribe(routerData => {
          if (routerData.displayOnly) {
            slots$ = slots$.pipe(switchMap(() => this.breakpointService.isUp(BREAKPOINT.lg)), map(isLargeResolution => {
              if (isLargeResolution) {
                return this.commonConfiguratorUtilsService.getSlotsFromLayoutConfiguration(this.layoutConfig, VariantConfiguratorPageLayoutHandler.templateName, VariantConfiguratorPageLayoutHandler.sectionDisplayOnlyName, BREAKPOINT.lg);
              } else {
                return this.commonConfiguratorUtilsService.getSlotsFromLayoutConfiguration(this.layoutConfig, VariantConfiguratorPageLayoutHandler.templateName, VariantConfiguratorPageLayoutHandler.sectionDisplayOnlyName, BREAKPOINT.xs);
              }
            }));
          }
        });
      }
      return slots$;
    }
    static {
      this.ɵfac = function VariantConfiguratorPageLayoutHandler_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VariantConfiguratorPageLayoutHandler)(i0.ɵɵinject(i1.ConfiguratorRouterExtractorService), i0.ɵɵinject(i2.BreakpointService), i0.ɵɵinject(i2.LayoutConfig), i0.ɵɵinject(i1.CommonConfiguratorUtilsService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: VariantConfiguratorPageLayoutHandler,
        factory: VariantConfiguratorPageLayoutHandler.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return VariantConfiguratorPageLayoutHandler;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 *  Contains the layout configuration for the overview configuration page. This configuration is
 *  optional as of version 4.2, and reduces the components that are rendered in the header section.
 *  It needs to be explicitly imported, otherwise the default configuration
 *  from VariantConfiguratorOverviewModule is active
 */
let VariantConfiguratorOverviewLayoutModule = /*#__PURE__*/(() => {
  class VariantConfiguratorOverviewLayoutModule {
    static {
      this.ɵfac = function VariantConfiguratorOverviewLayoutModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VariantConfiguratorOverviewLayoutModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: VariantConfiguratorOverviewLayoutModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfig({
          layoutSlots: {
            VariantConfigurationOverviewTemplate: {
              header: {
                slots: ['SiteLogo', 'VariantConfigOverviewExitButton', 'MiniCart']
              },
              headerDisplayOnly: {
                lg: {
                  slots: ['SiteContext', 'SiteLinks', 'SiteLogo', 'SearchBox', 'SiteLogin', 'MiniCart', 'NavigationBar']
                },
                xs: {
                  slots: ['PreHeader', 'SiteLogo', 'SearchBox', 'MiniCart']
                }
              },
              lg: {
                slots: ['VariantConfigOverviewHeader', 'VariantConfigOverviewBanner', 'VariantConfigOverviewNavigation', 'VariantConfigOverviewContent', 'VariantConfigOverviewBottombar']
              },
              slots: ['VariantConfigOverviewHeader', 'VariantConfigOverviewBanner', 'VariantConfigOverviewFilterButton', 'VariantConfigOverviewContent', 'VariantConfigOverviewBottombar']
            }
          }
        }), {
          provide: PAGE_LAYOUT_HANDLER,
          useExisting: VariantConfiguratorPageLayoutHandler,
          multi: true
        }]
      });
    }
  }
  return VariantConfiguratorOverviewLayoutModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Takes care of the configuration overview that visualizes the attribute value assignments that have been done already in a condensed, read-only form.
 * The end-user can switch between the interactive view and this overview.
 * Provides routing, assignment of ng components to CMS components and assignment of CMS components to the layout slots.
 * Some of the ng components on this view (tab bar, price summary and addToCart button) are shared between the interactive view and the overview.
 */
let VariantConfiguratorOverviewModule = /*#__PURE__*/(() => {
  class VariantConfiguratorOverviewModule {
    static {
      this.ɵfac = function VariantConfiguratorOverviewModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VariantConfiguratorOverviewModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: VariantConfiguratorOverviewModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [RouterModule.forChild([{
          // We can neither omit the path nor set to undefined
          // @ts-ignore
          path: null,
          component: PageLayoutComponent,
          data: {
            cxRoute: 'configureOverviewCPQCONFIGURATOR'
          },
          canActivate: [CmsPageGuard]
        }]), VariantConfiguratorOverviewLayoutModule]
      });
    }
  }
  return VariantConfiguratorOverviewModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Exposes the root modules that we need to load statically. Contains page mappings, route configurations
 * and feature configuration
 */
let RulebasedConfiguratorRootModule = /*#__PURE__*/(() => {
  class RulebasedConfiguratorRootModule {
    static forRoot() {
      return {
        ngModule: RulebasedConfiguratorRootModule
      };
    }
    static {
      this.ɵfac = function RulebasedConfiguratorRootModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || RulebasedConfiguratorRootModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: RulebasedConfiguratorRootModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [{
          provide: HttpErrorHandler,
          useExisting: ConfiguratorBadRequestHandler,
          multi: true
        }],
        imports: [CommonModule, CommonConfiguratorModule, RulebasedConfiguratorRootFeatureModule, VariantConfiguratorInteractiveModule, VariantConfiguratorOverviewModule, RulebasedConfiguratorRoutingModule.forRoot()]
      });
    }
  }
  return RulebasedConfiguratorRootModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ConfiguratorBadRequestHandler, CpqConfiguratorInteractiveModule, CpqConfiguratorLayoutModule, CpqConfiguratorOverviewModule, CpqConfiguratorRootModule, PRODUCT_CONFIGURATOR_RULEBASED_FEATURE, RulebasedConfiguratorRootFeatureModule, RulebasedConfiguratorRootModule, RulebasedConfiguratorRoutingModule, VariantConfiguratorInteractiveLayoutModule, VariantConfiguratorInteractiveModule, VariantConfiguratorOverviewLayoutModule, VariantConfiguratorOverviewModule, VariantConfiguratorPageLayoutHandler, defaultProductConfiguratorRulebasedComponentsConfig };
